<template>
  <div class="navbarContainer">
    <h1 class="largeBrand">
        <span class="logoIcon">
          <img ref="smallicon" class="logoSmall" src="../assets/global_kids_sm.jpg">
        </span>
        <span class="navTitle"> eats on feets </span>
    </h1>
    <h3 class="subTitle">
      Connecting Babies and Breastmilk Since 2010
    </h3>
    <b-navbar toggleable="lg" type="dark">
      <b-navbar-brand class="smallBrand">
        <span class="logoIcon">
          <img ref="smallicon" class="logoSmall" src="../assets/global_kids_sm.jpg">
        </span>

        <span class="logoIconSm">
          <img ref="smallicon" class="logoSmall" src="../assets/small-logo-sm.jpg">
        </span>

        <span class="navTitle"> eats on feets </span>
        <span class="subTitleSm"> Connecting Babies and Breastmilk Since 2010 </span>

      </b-navbar-brand>
      <b-navbar-toggle target="nav-sidebar" title="eats on feets">
      </b-navbar-toggle>

      <b-sidebar id="nav-sidebar" title="eats on feets" bg-variant="dark" text-variant="light" shadow header-class="eof-sidebar-header">
        <b-navbar-brand to="/">Home</b-navbar-brand> <br />
        <b-navbar-brand to="/4pillars">4 Pillars of Safe Milksharing</b-navbar-brand> <br />
        <b-navbar-brand to="/donatingAndRequesting">Donate or Request</b-navbar-brand> <br />
        <b-navbar-brand to="/blog">Blog</b-navbar-brand> <br />
        <b-navbar-brand to="/getInvolved">Get Involved</b-navbar-brand> <br />
        <b-navbar-brand to="/chapters">Chapters</b-navbar-brand> <br />
        <b-navbar-brand to="/about">About</b-navbar-brand> <br />
        <!-- <b-navbar-brand to="/contact">Contact</b-navbar-brand> <br /> -->
      </b-sidebar>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/" data-toggle="collapse">Home</b-nav-item>
          <b-nav-item to="/4pillars">4 Pillars of Safe Milksharing</b-nav-item>
          <b-nav-item to="/donatingAndRequesting">Donate or Request</b-nav-item>
          <b-nav-item to="/blog">Blog</b-nav-item>
          <b-nav-item to="/getInvolved">Get Involved</b-nav-item>
          <b-nav-item to="/chapters">Chapters</b-nav-item>
          <b-nav-item to="/about">About</b-nav-item>
          <!-- <b-nav-item to="/contact">Contact</b-nav-item> -->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>

export default {
  name: 'NavigationBar',
  methods: {
    ToggleNavBar() {
      const element = document.getElementsByClassName('navbar-toggler')[0]
      if (element.getAttribute('aria-expanded') === 'true') {
        element.click()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.eof-sidebar-header {
  font-family: 'Lexend Exa', 'Avenir', Helvetica, Arial, sans-serif !important;
}

#nav-sidebar{
  background-color: $primary-medium-color !important;
}

.logoIcon {
  display: inline-block;
  img {
    border-radius: 50%;
    max-width: 100px;
    margin-top: -20px;
  }
}

.logoIconSm {
  display: none;
  img: {
    display: none;
  }
}

.navbarContainer {
  .navbar-expand-lg .navbar-nav {
    margin-left: 110px;
  }
  box-shadow: black 1px 2px 2px 2px;

  h1 {
    padding-top: 20px;
    padding-left: 10px;
  }
  .subTitle {
    font-style:italic;
    color: white;
    margin-left: 137px;
    margin-top: -30px;
    font-size: 1.3em;
  }

  width: 100%;
  background-color: $primary-light-color;
  text-align: left;
  padding: 15px 15px 0px 15px;

  .navTitle {
    font-family: 'Lexend Exa', 'Avenir', Helvetica, Arial, sans-serif !important;
    font-weight: bold;
    font-size: 1.5em;
    color: white;
  }

}

.navbar {
  min-width: 300px;
  max-width: 1200px;
  margin: 0 auto;

  background-color: $primary-light-color;
  margin-bottom: 20px;

  .navbar-brand {
    display: block !important;
    white-space: nowrap;
    text-align: left;
    color:white;
  }
  .navbar-dark .navbar-nav .nav-link {
      color: rgba(255, 255, 255, 1 ) !important;
  }

  a {
    // font-weight: bold;
    font-size: 1.2em;
    color: $secondary-light-color;
    padding: 5px;
    &.router-link-exact-active {
      color: $base-color;
      font-weight: bold;
    }
    margin: 5px;
    white-space:nowrap;
    text-decoration:none;
  }
}

@media screen and (min-width: 992px) {
  .navbar {
    .smallBrand {
      display:none !important;
    }
  }
}

@media screen and (max-width: 991px) {
  .largeBrand {
    display:none;
  }

  .navbarContainer {
    .navTitle {
      font-size: 2em;
    }

    .subTitle {
      display: none;
    }
    .subTitleSm {
      display: block;
      margin-left: 117px;
      margin-top: -30px;
      font-size:.77em;
      font-style: italic;
    }
  }
}

@media screen and (max-width: 600px) {
  .navbarContainer {
    .navTitle {
      margin-top: -10px;
      font-size: 1.6em;
    }
    .subTitle {
      display: none;
    }

    .subTitleSm {
      margin-left: 93px;
      margin-top: -15px;
      font-size:.77em;
    }

  }

  .navbar-expand-lg .navbar-nav {
    margin-bottom: 0px;
  }

  .logoIcon {
    img {
      max-width: 80px;
    }
  }
}

@media screen and (max-width: 550px) {
  .navbarContainer {
    .navTitle {
      margin-top: -10px;
      font-size: 1.4em;
    }

    .subTitleSm {
      margin-left: 83px;
      margin-top: -15px;
      font-size:.57em;
    }
  }

  .navbar-expand-lg .navbar-nav {
    margin-bottom: 0px;
  }

  .logoIcon {
    margin-left: -10px;
    img {
      max-width: 80px;
    }
  }

}
@media screen and (max-width: 500px) {
  .navbarContainer {
    .navTitle {
      font-size: 1.3em;
    }
    .subTitleSm {
      margin-left: 53px;
      margin-top: -10px;
      font-size: .50em;
    }
    .birthday {
      font-size: 1.3em;
    }
  }

  .logoIcon {
    display: none;
  }

  .logoIconSm {
    margin-left: -20px;
    display: inline-block;
    img {
      border-radius: 50%;
      margin-top: -20px;
      max-width: 60px;
    }
  }

  .navbar-expand-lg .navbar-nav {
    margin-bottom: 0px;
    padding-bottom: 0px;
  }
}

@media screen and (max-width: 414px) {
  .navbarContainer {
    .navTitle {
      font-size: 1.2em;
      margin-top:-10px;
    }
    .subTitleSm {
      margin-left: 39px;
      margin-top: -10px;
      font-size: .50em;
    }
  }

  .logoIconSm {
    margin-left: -22px;
    img {
      width: 50px;
      margin-top: -10px;
    }
  }

  .navbar-expand-lg .navbar-nav {
    margin-bottom: 0px;
  }
  .navbar-toggler {
    margin-right: -8px;
  }
}

@media screen and (max-width: 375px) {
  .navbarContainer {
    .navTitle {
      font-size: 1.1em;
      margin-top:-10px;
    }

    .subTitleSm {
      margin-left: 25px;
      margin-top: -5px;
      font-size: .50em;
    }
  }

  .logoIconSm {
    margin-left: -27px;
    img {
      width: 40px;
      margin-top: -8px;
      margin-left: 3px;
    }
  }

  .navbar-expand-lg .navbar-nav {
    margin-bottom: 0px;
  }
  .navbar-toggler {
    margin-right: -8px;
  }
}

@media screen and (max-width: 325px) {
  .navbarContainer {
    .subTitleSm {
      display:none;
    }
  }
}

</style>
